module.exports = __webpack_public_path__ + "E9E41B3D18F21199B1617C255E3ABB03tel.a36228a0.png";